// extracted by mini-css-extract-plugin
export default {"blockquote":"bUK3e5","divider":"FGvF4n","quote":"MDEKUM","cite":"Lbn0_U"};